import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { useEffect, Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GetCookieToken } from "../../Cookie/GetCookie";
import axios from "axios";
import { ConvertDate } from "../../Function/ConvertDate";
const REACT_APP_API_E_OFFICE = process.env.REACT_APP_API_E_OFFICE;
const REACT_APP_API_CORS = process.env.REACT_APP_API_CORS;

const Sarabun = ({ setSarabunDoc }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const getData = async (type) => {
    setLoading(true);
    const userEofficeAccessToken = GetCookieToken("userEofficeAccessToken");
    const config = {
      headers: {
        Authorization: `${userEofficeAccessToken}`,
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
        'Access-Control-Allow-Credentials': true
      }
    }
    const url = `${REACT_APP_API_CORS}/e-office/proxy?url=${REACT_APP_API_E_OFFICE}/api/gateway/saraban/personal_list?page=1{q}limit=5`;
    await axios.get(url, config).then(async response => {
      if (response?.data?.status === 'success') {
        setData(response?.data?.data);
        setLoading(false);
        // setSarabunDoc(response?.data?.count_all);
      } else {
        setData([]);
        setLoading(false);
      }
    }).catch(error => {
    });
    setLoading(false);
  }

  useEffect(() => {
    const thisEffect = async () => {
      const userEofficeAccessToken = GetCookieToken("userEofficeAccessToken");
      if (userEofficeAccessToken) {
        await getData();
      }
    }
    thisEffect();
  }, [])

  return (
    <React.Fragment>
      <Row style={{ display: "flex", alignItems: "center" }} className="mt-3">
        <Col xs={9}>
          <h5>
            ตารางแสดงรายการหนังสือล่าสุด
          </h5>
        </Col>
        <Col className="text-end">
        </Col>
      </Row>
      <div class="my-2" style={{ border: '2px solid rgb(58, 64, 205)' }}></div>
      <Row>
        <Col>
          <div style={{ overflowX: "scroll" }}>
            <Table
              striped
              hover
              className="mt-2"
              style={{ whiteSpace: "nowrap" }}
            >
              <thead className="table-primary">
                <tr>
                  <th className="text-center">เลขที่หนังสือ</th>
                  <th className="text-center">หนังสือลงวันที่</th>
                  <th>จาก</th>
                  <th>เรื่อง</th>
                </tr>
              </thead>
              <tbody className="table-light">
                {(data.length > 0 && loading === false) ?
                  data.map((item, idx) => {
                    return (
                      <tr key={idx} style={{ cursor: "pointer" }} onClick={() => window.open(item.eoffice_url, "_blank")}>
                        <td className="text-center">{item.doc_no}</td>
                        <td className="text-center">{ConvertDate(item.add_date).toThaiDateFullDMY()}</td>
                        <td>{item.send_from}</td>
                        <td>{item.doc_header}</td>
                      </tr>
                    );
                  }) :
                  <tr key={'1'}>
                    <td className="text-center" colSpan={4}>
                      {loading ? <i class="fa-duotone fa-spinner-third fa-spin"></i> : 'ไม่พบข้อมูล'}
                    </td>
                  </tr>}
              </tbody>
            </Table>
            <div className="mt-2" style={{ textAlign: "end" }}>
              <Link to="https://eoffice.opdc.go.th/saraban/home/" target="_blank" className="btn btn-primary btn-md">
                ไปสารบรรณอิเล็กทรอนิกส์{" "}<i className="mdi mdi-arrow-right ms-1"></i>
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment >
  );
};

export default Sarabun;
